<template>
  <div class="col-empty">
    <div class="empty-icon">
      <i class="el-icon-wallet" style="font-size: 18px;"></i>
    </div>
    <p class="empty-title">Sin cobros</p>
    <p class="empty-sub">Solicita tu primer<br />cobro de servicio</p>
    <button
      v-if="$can('payments.manage')"
      class="empty-cta"
      @click="onPaymentAdd"
    >
      <svg width="10" height="10" viewBox="0 0 14 14" fill="none">
        <path
          d="M7 1v12M1 7h12"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
      Realizar cobro
    </button>
  </div>
</template>

<script>
export default {
  name: "PaymentEmptyComponent",
  methods: {
    onPaymentAdd() {
      this.$emit("onPaymentAdd");
    }
  }
};
</script>
